import createModelStore from "../../utils/createModelStore";
import CarModel from "../../services/CarModel";

const carModels = createModelStore<CarModel.Model, "carModels">("carModels");

export default carModels;
